import { render, staticRenderFns } from "./resourceManageSplitDialog.vue?vue&type=template&id=915b8b66&scoped=true"
import script from "./resourceManageSplitDialog.vue?vue&type=script&lang=js"
export * from "./resourceManageSplitDialog.vue?vue&type=script&lang=js"
import style0 from "./resourceManageSplitDialog.vue?vue&type=style&index=0&id=915b8b66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915b8b66",
  null
  
)

export default component.exports